import { SavedReportsCard } from "@/Features/SavedReports";
import { saveTimeEntryReport } from "../../../../api";

export const SavedReports = ({ reportInfo }) => (
  <SavedReportsCard reportInfo={reportInfo} saveReport={saveTimeEntryReport} />
);
